export default __webpack_public_path__ + "static/media/MeterChange.c88cd9e8.svg";